var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalRecords(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2856 3.07129H18.857C19.3117 3.07129 19.7478 3.25191 20.0692 3.57339C20.3906 3.89488 20.5713 4.33091 20.5713 4.78557V21.9284C20.5713 22.3831 20.3906 22.8192 20.0692 23.1406C19.7478 23.462 19.3117 23.6427 18.857 23.6427H5.14275C4.68809 23.6427 4.25206 23.462 3.93056 23.1406C3.60908 22.8192 3.42847 22.3831 3.42847 21.9284V4.78557C3.42847 4.33091 3.60908 3.89488 3.93056 3.57339C4.25206 3.25191 4.68809 3.07129 5.14275 3.07129H7.71418",
    stroke: "#040506",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5713 1.35693H9.4284C8.48163 1.35693 7.71411 2.12444 7.71411 3.07122V3.92836C7.71411 4.87513 8.48163 5.64265 9.4284 5.64265H14.5713C15.518 5.64265 16.2855 4.87513 16.2855 3.92836V3.07122C16.2855 2.12444 15.518 1.35693 14.5713 1.35693Z",
    stroke: "#040506",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8046 9.43115C10.3981 9.43115 10.0685 9.76071 10.0685 10.1672V12.2375H7.99829C7.59176 12.2375 7.26221 12.5671 7.26221 12.9736V15.3659C7.26221 15.7724 7.59176 16.102 7.99829 16.102H10.0685V18.1722C10.0685 18.5786 10.3981 18.9083 10.8046 18.9083H13.1969C13.6034 18.9083 13.933 18.5786 13.933 18.1722V16.102H16.0032C16.4098 16.102 16.7393 15.7724 16.7393 15.3659V12.9736C16.7393 12.5671 16.4098 12.2375 16.0032 12.2375H13.933V10.1672C13.933 9.76071 13.6034 9.43115 13.1969 9.43115H10.8046Z",
    stroke: "#040506",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalRecords);
export default __webpack_public_path__ + "static/media/medical-records.5c4ea79a8d51b1ea6735fc8be985fa5d.svg";
export { ForwardRef as ReactComponent };